import { useEffect } from 'react';
import './OctazookaAnimation.css';

export default function OctazookaAnimation({ playerRef, opponentRef, onComplete }) {
  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const container =
      playerEl.closest('.battle-screen') ||
      playerEl.closest('.battle-container') ||
      playerEl.closest('.battle-bg') ||
      document.querySelector('.battle-screen') ||
      document.querySelector('.battle-container') ||
      document.querySelector('.battle-bg') ||
      document.body;
    const rect = container.getBoundingClientRect();

    const p = playerEl.getBoundingClientRect();
    const o = opponentEl.getBoundingClientRect();

    const playerX = Math.round((p.left + p.width / 2) - rect.left);
    const playerY = Math.round((p.top + p.height / 2) - rect.top);
    const opponentX = Math.round((o.left + o.width / 2) - rect.left);
    const opponentY = Math.round((o.top + o.height / 2) - rect.top);

    const clampX = (x, m = 0) => Math.min(Math.max(x, m), Math.round(rect.width) - m);
    const clampY = (y, m = 0) => Math.min(Math.max(y, m), Math.round(rect.height) - m);

    const dx = opponentX - playerX;
    const dy = opponentY - playerY;

    const elements = [];

    playerEl.classList.add('octazooka-user-pressurize');
    console.log('Octazooka Phase 1: Pressurize');

    const aura = document.createElement('div');
    aura.className = 'octazooka-pressure-aura';
    aura.style.left = `${clampX(playerX, 110) - 110}px`;
    aura.style.top = `${clampY(playerY, 110) - 110}px`;
    aura.style.width = '220px';
    aura.style.height = '220px';
    container.appendChild(aura);
    elements.push(aura);

    for (let i = 0; i < 10; i++) {
      const swirl = document.createElement('div');
      swirl.className = 'octazooka-ink-swirl';
      const a = (i / 10) * 360;
      const r = 85 + (i % 2) * 10;
      const x = playerX + Math.cos(a * Math.PI / 180) * r;
      const y = playerY + Math.sin(a * Math.PI / 180) * r;
      swirl.style.left = `${clampX(x, 6) - 6}px`;
      swirl.style.top = `${clampY(y, 6) - 6}px`;
      swirl.style.animationDelay = `${i * 35}ms`;
      swirl.textContent = '🫧';
      container.appendChild(swirl);
      elements.push(swirl);
    }

    const phase2Timer = setTimeout(() => {
      console.log('Octazooka Phase 2: Blob Travel');
      playerEl.classList.add('octazooka-user-fire');

      const blob = document.createElement('div');
      blob.className = 'octazooka-blob-projectile';
      blob.style.left = `${clampX(playerX, 22) - 22}px`;
      blob.style.top = `${clampY(playerY, 22) - 22}px`;
      blob.style.width = '44px';
      blob.style.height = '44px';
      blob.style.setProperty('--target-x', `${dx}px`);
      blob.style.setProperty('--target-y', `${dy}px`);
      container.appendChild(blob);
      elements.push(blob);

      for (let i = 0; i < 8; i++) {
        const tmr = setTimeout(() => {
          const trail = document.createElement('div');
          trail.className = 'octazooka-blob-trail';
          const prog = i / 8;
          const tx = playerX + dx * prog;
          const ty = playerY + dy * prog;
          trail.style.left = `${clampX(tx, 10) - 10}px`;
          trail.style.top = `${clampY(ty, 10) - 10}px`;
          container.appendChild(trail);
          elements.push(trail);
        }, i * 45);
        elements.push({ type: 'timer', timer: tmr });
      }
    }, 600);
    elements.push({ type: 'timer', timer: phase2Timer });

    const phase3Timer = setTimeout(() => {
      console.log('Octazooka Phase 3: Ink Impact');
      opponentEl.classList.add('octazooka-opponent-obscured');

      const splash = document.createElement('div');
      splash.className = 'octazooka-ink-splash';
      splash.style.left = `${clampX(opponentX, 120) - 120}px`;
      splash.style.top = `${clampY(opponentY, 120) - 120}px`;
      splash.style.width = '240px';
      splash.style.height = '240px';
      container.appendChild(splash);
      elements.push(splash);

      for (let i = 0; i < 3; i++) {
        const ringT = setTimeout(() => {
          const ring = document.createElement('div');
          ring.className = 'octazooka-ink-ring';
          ring.style.left = `${clampX(opponentX, 100) - 100}px`;
          ring.style.top = `${clampY(opponentY, 100) - 100}px`;
          ring.style.width = '200px';
          ring.style.height = '200px';
          ring.style.animationDelay = `${i * 70}ms`;
          container.appendChild(ring);
          elements.push(ring);
        }, i * 80);
        elements.push({ type: 'timer', timer: ringT });
      }

      for (let i = 0; i < 14; i++) {
        const drop = document.createElement('div');
        drop.className = 'octazooka-droplet';
        const a = (i / 14) * 360;
        const r = 60 + Math.random() * 50;
        const x = opponentX + Math.cos(a * Math.PI / 180) * r;
        const y = opponentY + Math.sin(a * Math.PI / 180) * r;
        drop.style.left = `${clampX(x, 6) - 6}px`;
        drop.style.top = `${clampY(y, 6) - 6}px`;
        drop.style.animationDelay = `${i * 25}ms`;
        drop.textContent = '💧';
        container.appendChild(drop);
        elements.push(drop);
      }
    }, 1100);
    elements.push({ type: 'timer', timer: phase3Timer });

    const phase4Timer = setTimeout(() => {
      console.log('Octazooka Phase 4: Afterglow');
      playerEl.classList.remove('octazooka-user-fire');
      const fade = document.createElement('div');
      fade.className = 'octazooka-afterglow';
      fade.style.left = `${clampX(playerX, 70) - 70}px`;
      fade.style.top = `${clampY(playerY, 70) - 70}px`;
      fade.style.width = '140px';
      fade.style.height = '140px';
      container.appendChild(fade);
      elements.push(fade);
    }, 1500);
    elements.push({ type: 'timer', timer: phase4Timer });

    const cleanupTimer = setTimeout(() => {
      playerEl.classList.remove('octazooka-user-pressurize', 'octazooka-user-fire');
      opponentEl.classList.remove('octazooka-opponent-obscured');
      elements.forEach(it => {
        if (it.type === 'timer') clearTimeout(it.timer);
        else if (it && it.parentNode) it.remove();
      });
      onComplete();
    }, 1900);

    return () => {
      clearTimeout(cleanupTimer);
      playerEl.classList.remove('octazooka-user-pressurize', 'octazooka-user-fire');
      opponentEl.classList.remove('octazooka-opponent-obscured');
      elements.forEach(it => {
        if (it.type === 'timer') clearTimeout(it.timer);
        else if (it && it.parentNode) it.remove();
      });
    };
  }, [playerRef, opponentRef, onComplete]);

  return null;
}

OctazookaAnimation.moveType = 'water';
